import { useCallback } from "react";

import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router";

import { routes } from "config/routes";
import { Button } from "ui/Button/Button";
import { Modal } from "ui/Modal/Modal";
import { BodyM, HeaderS } from "ui/Typography/Typography";

import { useInboundStore } from "../stores/inboundStore/useInboundStore";

export function UnclaimedListConfirmationModal() {
  const navigate = useNavigate();
  const setInboundUIState = useInboundStore((state) => state.setInboundUIState);
  const handleOnClick = useCallback(() => {
    setInboundUIState({ isUnclaimedListConfirmationModalVisible: false });
    navigate(routes.inbound.root);
  }, [navigate, setInboundUIState]);
  return (
    <Modal trapFocus={false} closeOnOverlayClick={false} isCentered isOpen onClose={() => {}}>
      <Modal.Content marginX="s300">
        <Modal.Body textAlign="center" paddingY="0" paddingX="s200">
          <HeaderS mt="s300">
            <FormattedMessage id="components.unclaimed-list-confirmation-modal.title" />
          </HeaderS>
          <BodyM mt="s300" color="grey.700">
            <FormattedMessage id="components.unclaimed-list-confirmation-modal.body" />
          </BodyM>
        </Modal.Body>
        <Modal.Footer>
          <Button mt="s100" onClick={handleOnClick} isFullWidth variant="primary" size="lg">
            <FormattedMessage id="generic.actions.okay" />
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
}
